import React, { useRef, useEffect } from "react";
import { HStack, Input } from "@chakra-ui/react";

export const OtpInput = ({ value, onChange, isDisabled = false }) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on initial render
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, e) => {
    const inputValue = e.target.value;
    
    // Allow only digits
    if (!/^\d*$/.test(inputValue)) return;
    
    // Handle paste
    if (inputValue.length > 1) {
      handlePaste(inputValue);
      return;
    }
    
    const newOtp = value.split("");
    newOtp[index] = inputValue;
    const newOtpString = newOtp.join("");
    
    onChange(newOtpString);
    
    // Auto focus to next input
    if (inputValue && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (pastedValue) => {
    const numericValue = pastedValue.replace(/\D/g, "").slice(0, 6);
    const newOtp = numericValue.padEnd(6, "").split("");
    onChange(newOtp.join(""));
    
    // Focus the last filled input or the first empty one
    const nextIndex = Math.min(numericValue.length, 5);
    setTimeout(() => {
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }, 0);
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !value[index] && index > 0 && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  return (
    <HStack spacing={3}>
      {Array.from({ length: 6 }, (_, index) => (
        <Input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ""}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onFocus={handleFocus}
          disabled={isDisabled}
          textAlign="center"
          fontSize="lg"
          fontWeight="bold"
          width="50px"
          height="50px"
          borderRadius="md"
          borderWidth="2px"
          _focus={{
            borderColor: "blue.500",
            boxShadow: "0 0 0 1px blue.500",
          }}
        />
      ))}
    </HStack>
  );
};